import { Component, inject } from "@angular/core";
import { LoadingIndicatorService } from "./loading-indicator.service";

@Component({
    selector: "kno2-loading-indicator",
    imports: [],
    template: `
        @if (isLoading()) {
            <div class="kno2-loading"><img src="/images/ajax-loader.gif" /></div>
        }
    `
})
export class LoadingIndicatorComponent {
    private readonly loadingIndicatorService = inject(LoadingIndicatorService);
    protected isLoading = this.loadingIndicatorService.isLoading;
}
